export enum PaymentMethodEnum {
    BTFDoxpay = 'BTF-Dox pay',
    BTRBankTransfer = 'BTR-Bank Transfer',
    CASCash = 'CAS-Cash',
    CHKCheck = 'CHK-Check',
    DEQDEQ30Days = 'DEQ-DEQ-30 Days',
    DPEDoxpay = 'DPE-Dox pay',
    EDIEDITCard30da = 'EDI-EDI-T Card30da',
    FLCLCforeign = 'FLC-L/C foreign',
    FLRForeignLCRec = 'FLR-Foreign L/C Rec',
    FOCFreeofCost = 'FOC-Free of Cost',
    ILCLCInland = 'ILC-L/C: Inland',
    TCSTradeCardSigh = 'TCS-Trade Card-Sigh',
    TTETelexTransfer = 'TTE-Telex Transfer',


}
